var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"creator-v3-separator"},[(_vm.$slots.default)?_c('div',{staticClass:"creator-v3-separator-text"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }